import * as React from 'react';
import { TimelineGradient } from '../InsightTimeline.styles';
export var GradientSpan = function (_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height, left = _a.left;
    return (React.createElement("foreignObject", { x: x, y: y, width: width, height: height },
        React.createElement(TimelineGradient, { left: left })));
};
//# sourceMappingURL=GradientSpan.js.map